export const defaultLocale = 'en';
// TODO: i18n Раскомментировать чтобы включить немецкий в роутинге
export const locales = [defaultLocale /*, 'de'*/] as const;
export type RouterLocale = (typeof locales)[number];

export const translatedPrefixes = locales.slice(1);

export const urlPrefixes: string[] = ['', ...translatedPrefixes];
